import { Link } from "react-router";
import { Button } from "@/components/ui/button";

export function NotFoundRoute() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
      <p className="text-sm text-muted-foreground">
        The page you&apos;re looking for doesn&apos;t exist.
      </p>
      <Button render={<Link to="/home">Back to dashboard</Link>} />
    </div>
  );
}
